import { render, staticRenderFns } from "./MarketplaceFooter.vue?vue&type=template&id=fd415ba2&scoped=true&"
import script from "./MarketplaceFooter.vue?vue&type=script&lang=js&"
export * from "./MarketplaceFooter.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceFooter.vue?vue&type=style&index=0&id=fd415ba2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd415ba2",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BIconGlobe} from 'bootstrap-vue'
    installComponents(component, {BIconGlobe})
    

export default component.exports